import type { AccessMode, DeviceBrowser, DevicePlatform } from './types';

/**
 * 端末・ブラウザ・アクセス形態の検知ロジック。
 * Mixpanel / Amplitude の両 provider およびファサードで共有する。
 *
 * window/navigator/document に依存するため、ブラウザ環境でのみ呼び出すこと。
 */

export const detectAccessMode = (): AccessMode => {
  const isInStandaloneMode = window.matchMedia('(display-mode: standalone)').matches;
  // iOS Safari の standalone は navigator.standalone（非標準プロパティ）で判定する
  const navigatorWithStandalone = navigator as Navigator & { standalone?: boolean };
  const isIOSStandalone = 'standalone' in navigator && navigatorWithStandalone.standalone === true;
  return isInStandaloneMode || isIOSStandalone ? 'pwa' : 'browser';
};

export const detectPlatform = (): DevicePlatform => {
  const ua = window.navigator.userAgent;
  if (/iPad|iPhone|iPod/.test(ua) || (ua.includes('Mac') && 'ontouchend' in document)) return 'ios';
  if (/Android/.test(ua)) return 'android';
  return 'desktop';
};

export const detectBrowser = (): DeviceBrowser => {
  const ua = window.navigator.userAgent.toLowerCase();
  // navigator.vendor は一部ブラウザで非標準のため型を明示して安全に参照する
  const navigatorWithVendor = window.navigator as Navigator & { vendor?: string };
  const vendor = navigatorWithVendor.vendor?.toLowerCase() || '';
  const isWebkit = 'WebkitAppearance' in document.documentElement.style;
  const platform = detectPlatform();

  if (/edg/.test(ua)) return 'edge';
  if (/firefox/.test(ua)) return 'firefox';
  if (platform === 'ios' && /crios/.test(ua)) return 'chrome';
  if (platform === 'android' && /chrome/.test(ua)) return 'chrome';
  if (isWebkit && /apple computer/.test(vendor) && /safari/.test(ua) && !/chrome/.test(ua)) return 'safari';
  if (/chrome/.test(ua) && !/edg/.test(ua)) return 'chrome';
  return 'other';
};
